exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-add-del[data-v-5fa53dee]{font-weight:700;font-size:18px;padding:.25rem;line-height:1}", ""]);

// exports
